import { makeRequest } from './client'
import billMutations from './bill/mutations'
import billQueries from './bill/queries'
import generatedReportQueries from './generated-reports/queries'
import generatedReportMutations from './generated-reports/mutations'
import officeCardQueries from './office-card/queries'
import officeCardMutations from './office-card/mutations'

const bills = {
  payBill: (variables) => makeRequest(billMutations.PAY_BILL, variables),
  getBill: (variables) => makeRequest(billQueries.GET_BILL, variables),
  getBills: (variables) => makeRequest(billQueries.GET_BILLS, variables),
  getBillByToken: (variables) => makeRequest(billQueries.GET_BILL_BY_TOKEN, variables),
  deleteBill: (variables) => makeRequest(billMutations.DELETE_BILL, variables),
  sendBill: (variables) => makeRequest(billMutations.SEND_BILL, variables),
  createBill: (variables) => makeRequest(billMutations.CREATE_BILL, variables),
  updateBill: (variables) => makeRequest(billMutations.UPDATE_BILL, variables)
}

const generatedReports = {
  getGeneratedReports: (variables) => makeRequest(generatedReportQueries.GET_GENERATED_REPORTS, variables, 'reports'),
  getGeneratedReport: (variables) => makeRequest(generatedReportQueries.GET_GENERATED_REPORT, variables, 'reports'),
  deleteGeneratedReport: (variables) => makeRequest(generatedReportMutations.DELETE_GENERATED_REPORT, variables, 'reports')
}

const officeCards = {
  getOfficeCard: (variables) => makeRequest(officeCardQueries.GET_OFFICE_CARD, variables),
  getCardByOffice: (variables) => makeRequest(officeCardQueries.GET_CARD_BY_OFFICE, variables),
  createOfficeCard: (variables) => makeRequest(officeCardMutations.CREATE_OFFICE_CARD, variables),
  updateOfficeCard: (variables) => makeRequest(officeCardMutations.UPDATE_OFFICE_CARD, variables),
  deleteOfficeCard: (variables) => makeRequest(officeCardMutations.DELETE_OFFICE_CARD, variables)
}

const methods = { bills, generatedReports, officeCards }

export default methods